import { PasswordInput, PasswordInputProps } from 'deprecated-component-library';
import React from 'react';

import { PasswordResetHelperText } from './PasswordResetHelperText';

export const HelperTextAwarePasswordInput = React.forwardRef<HTMLDivElement, PasswordInputProps>((props, ref) => (
  <PasswordInput {...props} helperText={<PasswordResetHelperText helperText={props.helperText} />} ref={ref} />
));
HelperTextAwarePasswordInput.displayName = 'HelperTextAwarePasswordInput';
